import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import InvoicesBody from 'components/Admin/Invoices';
import Nav from 'components/Admin/Nav/Nav';

const Invoices = () => {
    return (
        <>
            <AdminHeader />
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="6" m="9" l="16">
                        <Gap top bottom>
                            <Nav />
                            <InvoicesBody />
                        </Gap>
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </>
    );
};

export default Invoices;
